import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import {
  ActiveIngredientsSettingState,
  StateActiveIngredientSetting,
} from '../../activeingredientsetting.model';
import * as ActiveIngredientSettingActions from '../actions/activeingredientsetting.actions';

export const adapter: EntityAdapter<StateActiveIngredientSetting> =
  createEntityAdapter<StateActiveIngredientSetting>();
export const initialState: ActiveIngredientsSettingState = adapter.getInitialState({});

export const activeIngredientSettingsReducer = createReducer<ActiveIngredientsSettingState>(
  initialState,
  on(
    ActiveIngredientSettingActions.loadActiveIngredientSettingsSuccess,
    (state, { activeIngredientSettings }) => {
      const activeIngredientSettingsWithIds = activeIngredientSettings.map(
        (activeIngredientSetting) => ({
          ...activeIngredientSetting,
          id: activeIngredientSetting.id,
        }),
      );
      return adapter.setAll(activeIngredientSettingsWithIds, state);
    },
  ),
);
